import React from 'react'
import PropTypes from 'prop-types'
import { sendGAEvent, sendGA4 } from '../../../utils/common'

const isLeftClickEvent = (event) => event.button === 0

const isModifiedEvent = (event) =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)

const Link = (props) => {
  const {
    to,
    disabled,
    children,
    onClick,
    onMouseEnter,
    className,
    ga,
    target,
    title,
    tabIndex,
    HTMLAttributes,
    skipTo,
    allowPropagation = false,
    useGA4,
  } = props

  const handleClick = (event) => {
    // Link is disabled, no need to perform any action on it
    if (disabled) {
      event.preventDefault()
      return
    }

    if (useGA4 && ga) {
      sendGA4('user_click', ga)
    } else if (ga) {
      sendGAEvent(ga)
    }

    if (typeof onClick === 'function') {
      onClick(event)
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return
    }

    if (event.defaultPrevented === true) {
      return
    }

    event.preventDefault()
    // stop propogation is done by default for library component becuase no handling is expected on the page/document.
    if (!allowPropagation) {
      event.stopPropagation()
    }

    if (skipTo) {
      return
    }

    if (target === '_blank') {
      window.open(to, '_blank')
    } else {
      window.location.href = to
    }
  }

  const rel =
    target === '_blank'
      ? 'noopener nofollow noreferrer sponsored'
      : 'noopener sponsored'

  if (skipTo) {
    return (
      <span
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        className={className}
        disabled={disabled}
        {...HTMLAttributes}
      >
        {children}
      </span>
    )
  }

  return (
    <a
      // eslint-disable-next-line no-script-url
      href={to || `javascript:void(0);`}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      rel={rel}
      className={className}
      disabled={disabled}
      title={title}
      tabIndex={tabIndex}
      target={target}
      {...HTMLAttributes}
    >
      {children}
    </a>
  )
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  className: PropTypes.string,
  ga: PropTypes.shape({
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  target: PropTypes.string,
  title: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  HTMLAttributes: PropTypes.shape({}),
  skipTo: PropTypes.bool,
  allowPropagation: PropTypes.bool,
  useGA4: PropTypes.bool,
}

Link.defaultProps = {
  disabled: false,
  onClick: undefined,
  onMouseEnter: undefined,
  className: '',
  ga: undefined,
  target: undefined,
  HTMLAttributes: {},
  skipTo: false,
  title: undefined,
  tabIndex: undefined,
  allowPropagation: false,
  useGA4: false,
}

export default Link
